export const EMPLOYEE_TYPES_ENUM = {
  OWNER: "OWNER",
  ADMIN: "COMPANY_ADMIN",
  STAFF: "STAFF",
};
